/**
 * Path: src/core/plugins/index.ts
 * Task: Registers all application plugins like Vuetify and Pinia to the main Vue instance centrally.
 */
import type { App } from 'vue';
import vuetify from './vuetifyConfig'; // FIX: Removed the .js extension and it is already a default import
import pinia from './pinia'; // FIX: Removed the .js extension

export function registerPlugins(app: App): void {
  app
    .use(vuetify)
    .use(pinia);
}
